import { Pipe, PipeTransform } from '@angular/core';
import { TenantUserPrivilegesService } from 'src/app/tenant-selector/services/tenant-user-privileges.service';

@Pipe({
  name: 'checkPermission',
  standalone: true,
})
export class CheckPermissionPipe implements PipeTransform {
  constructor(private tenantUserPrivileges: TenantUserPrivilegesService) {}

  transform(privilege: string): boolean {
    return this.tenantUserPrivileges.userHasPrivilege(privilege);
  }
}
